(ns app.client-log
  "Client-side helper to send funnel/diagnostic events to the server, where
   they are logged via app.log.core/log alongside the rest of the structured
   log. The server-side allow-list in app.client-log.core determines which
   event keys are accepted."
  (:require [app.util.transit :as transit]))

(defn log!
  "Fire-and-forget POST to /internal/ui-state. Errors are swallowed — a
   failed log call must never break the UI."
  ([event]
   (log! event {}))
  ([event data]
   ;; keepalive lets the request survive a page navigation right after
   ;; the call (e.g. logging a click on an external OAuth link).
   (-> (js/fetch "/internal/ui-state"
                 #js {:method "POST"
                      :keepalive true
                      :headers #js {"Content-Type" "application/transit+json"}
                      :body (transit/transit-encode {:event event
                                                     :data data})})
       (.catch (fn [_e] nil)))))
